<template>
    <div>
        <Head :title="`${form.name}`"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link class="text-indigo-400 hover:text-indigo-600" :href="$route('products.index')">
                Продукти
            </Link>
            <span class="text-indigo-400 font-medium"> /</span> {{ form.name }}
        </h1>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="update" enctype="multipart/form-data">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.name" :error="form.errors.name"
                                class="pb-8 pr-6 w-full" label="Назва"/>
                    <text-input v-model="form.price" :error="form.errors.price"
                                class="pb-8 pr-6 w-full lg:w-1/2" label="Ціна (грн)" type="number" step="0.01" min="0"/>
                    <text-input v-model="form.quantity" :error="form.errors.quantity"
                                class="pb-8 pr-6 w-full lg:w-1/2" label="Кількість" type="number" min="0"/>
                    <div class="pb-8 pr-6 w-full">
                        <label class="form-label" for="description">Опис</label>
                        <ckeditor :editor="editor" v-model="form.description" :config="editorConfig"
                                  id="description" class="description"/>
                    </div>
                    <div v-if="product.images" class="pb-4 pr-6 w-full">
                        <p class="form-label mb-2">Поточне зображення</p>
                        <img :src="`/storage/${product.images}`" class="w-48 rounded" :alt="form.name"/>
                    </div>
                    <drag-and-drop v-model="form.images" :error="form.errors.images"
                                   class="pb-8 pr-6 w-full lg:w-1/2"
                                   type="file" accept="image/*" label="Замінити зображення"/>
                    <div class="pb-8 pr-6 w-full flex items-center">
                        <label class="form-label mr-4 mb-0">Активний</label>
                        <input type="checkbox" v-model="form.is_active" class="w-5 h-5"/>
                    </div>
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">
                        Видалити
                    </button>
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
                        Оновити
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import DragAndDrop from '@/Shared/DragAndDrop'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import CKEditor from '@ckeditor/ckeditor5-vue'

export default {
    components: {
        Head, Link, LoadingButton, TextInput, DragAndDrop,
        ckeditor: CKEditor.component,
    },
    layout: Layout,
    props: {
        product: Object,
    },
    remember: 'form',
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {},
            form: this.$inertia.form({
                _method: 'put',
                name: this.product.name,
                description: this.product.description,
                price: this.product.price,
                quantity: this.product.quantity,
                images: null,
                is_active: this.product.is_active,
            }),
        }
    },
    methods: {
        update() {
            this.form.post(this.$route('products.update', this.product.id))
        },
        destroy() {
            if (confirm('Ви впевнені що хочете видалити продукт?')) {
                this.$inertia.delete(this.$route('products.destroy', this.product.id))
            }
        },
    },
}
</script>

<style scoped>
:deep(.ck.ck-editor__editable_inline) {
    min-height: 300px;
}
.description {
    width: 100%;
}
</style>
